<div class="preview-backdrop" [ngClass]="{ 'backdrop-loading': !isLoaded && type == 'pdf' }"></div>
<div class="preview-stage">
    <div class="preview-header">
        <div class="info">
            <!-- <div class="user">{{item.answer_user.full_name}}</div>
            <div class="date">{{item.date | amCalendar:moment_calendar_format}}</div> -->
        </div>
        <i class="feather x close-file-preview" (click)="close()"><span>Close</span></i>
    </div>
    <div style="margin:auto;" *ngIf="
      type != 'pdf' &&
      type != 'png' &&
      type != 'jpg' &&
      type != 'jpeg' &&
      type != 'gif'
    ">
        <i class="feather eye-off x3" style="color:#485364"></i>
        <h4>Unable to preview this file</h4>
        <p>
            Please
            <a [href]="url" (click)="downloadFile($event)" style="display:inline; text-decoration:none !important; margin:0;"><i
                    class="feather download"></i> download</a>
            it instead.
        </p>
    </div>
    <pdf-viewer class="preview-element" [src]="url" [render-text]="true" [show-all]="false" [zoom]="zoom" [page]="page"
        (after-load-complete)="afterLoadComplete($event)" style="display: block;max-width: 100%;margin: auto;"
        *ngIf="type == 'pdf'"></pdf-viewer>
    <img class="preview-element" [ngClass]="{ zoomed: zoomed }" (click)="zoomed ? (zoomed = false) : (zoomed = true)"
        [src]="url" *ngIf="type == 'png' || type == 'jpg' || type == 'jpeg' || type == 'gif'" />
</div>

<div class="preview-navigation" *ngIf="isLoaded || type != 'pdf'">
    <div class="preview-navigation-item" *ngIf="type == 'pdf'">
        <div class="label">Page</div>
        <div>
            <input class="text-right" type="text" [(ngModel)]="page" /><span style="opacity:.6">
                / {{ totalPages }}&nbsp;&nbsp;</span>
        </div>
        <div>
            <button (click)="prevPage()" [disabled]="page === 1">
                <i class="feather chevron-up" tooltip="Previous Page"></i>
            </button>
            <button (click)="nextPage()" [disabled]="page === totalPages">
                <i class="feather chevron-down" tooltip="Next Page"></i>
            </button>
        </div>
    </div>
    <div class="preview-navigation-item" *ngIf="type == 'pdf'">
        <div class="label">Zoom</div>
        <div>
            <input type="text" disabled [ngModel]="zoom" maxlength="3" style="max-width:25px" />
        </div>
        <div>
            <button (click)="zoomOut()" [disabled]="zoom <= 1">
                <i class="feather minus" tooltip="Zoom Out"></i>
            </button>
            <button (click)="zoomIn()" [disabled]="zoom >= 2">
                <i class="feather plus" tooltip="Zoom In"></i>
            </button>
        </div>
    </div>
    <div class="preview-navigation-item" *ngIf="type == 'pdf'">
        <a [href]="url" (click)="downloadFile($event)" #downloadButton target="_blank" rel="noreferrer noopener" [download]="file.filename">
            <i class="feather download" tooltip="Download"></i>
        </a>
    </div>
    <div class="preview-navigation-item" *ngIf="type != 'pdf'">
        <a [href]="url" (click)="downloadFile($event)" #downloadButton target="_blank" rel="noreferrer noopener" [download]="file.filename">
            <i class="feather download" tooltip="Download"></i> Download&nbsp;&nbsp;
        </a>
    </div>
</div>